import type { ConversationClusteringFailureLensOutputV2 } from "@/types_api/backend/transport/get_latest_failure_pattern_run_output_response"

/** Resolves required table identities and checks that issue mappings are consistent. */
export function resolveFailureTableIds(
  lens: ConversationClusteringFailureLensOutputV2,
): Map<string, string> {
  const tableIds = new Map<string, string>()
  const tableIdByConversationId = new Map<string, string>()
  const conversationIdByTableId = new Map<string, string>()
  for (const issue of lens.issues) {
    const { issue_id, conversation_id } = issue
    const simulation_output_id =
      "simulation_output_id" in issue ? issue.simulation_output_id : undefined
    if (
      typeof simulation_output_id !== "string" ||
      simulation_output_id.length === 0 ||
      tableIds.has(issue_id) ||
      (tableIdByConversationId.has(conversation_id) &&
        tableIdByConversationId.get(conversation_id) !==
          simulation_output_id) ||
      (conversationIdByTableId.has(simulation_output_id) &&
        conversationIdByTableId.get(simulation_output_id) !== conversation_id)
    ) {
      throw new Error("Invalid failure issue table identity")
    }
    tableIds.set(issue_id, simulation_output_id)
    tableIdByConversationId.set(conversation_id, simulation_output_id)
    conversationIdByTableId.set(simulation_output_id, conversation_id)
  }

  return tableIds
}
